import { AfterViewInit, ChangeDetectionStrategy, Component, ComponentRef, Injector, ViewChild, ViewContainerRef, ɵcreateInjector as createInjector } from '@angular/core'

import { MediaService } from '@alliance/shared/utils'
import { RxStateComponent } from '@alliance/shared/models'

@Component({
  selector: 'alliance-clubs-shell',
  template: '<div #element></div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellComponent
  extends RxStateComponent<{
    isMobileScreen: boolean
  }>
  implements AfterViewInit {
  @ViewChild('element', { read: ViewContainerRef, static: true })
  public element: ViewContainerRef | undefined = undefined
  private component: ComponentRef<unknown> | undefined = undefined

  public constructor(private mediaService: MediaService, private injector: Injector) {
    super()

    this.initState({
      isMobileScreen: this.mediaService.select('isMobileScreen')
    })
  }

  public ngAfterViewInit(): void {
    this.hold(this.select('isMobileScreen'), isMobile => this.render(!!isMobile))
  }

  private render(isMobile: boolean): void {
    if (this.component) {
      this.component?.destroy()
      this.element?.clear()
    }

    isMobile ? this.renderMobile() : this.renderDesktop()
  }

  private renderDesktop(): void {
    import('@alliance/clubs/shell-desktop').then(({ ClubsShellDesktopModule }) => {
      const injector = createInjector(ClubsShellDesktopModule, this.injector)
      const module = injector.get(ClubsShellDesktopModule)
      if (this.element) {
        this.component = module.renderPage(this.element)
      }
    })
  }

  private renderMobile(): void {
    import('@alliance/clubs/shell-mobile').then(({ ClubsShellMobileModule }) => {
      const injector = createInjector(ClubsShellMobileModule, this.injector)
      const module = injector.get(ClubsShellMobileModule)
      if (this.element) {
        this.component = module.renderPage(this.element)
      }
    })
  }
}
